/**
 * Ставит перехватчики эмуляции плохого интернета до всего остального кода (IMGM-1435).
 *
 * Импортируется первой строкой `src/index.tsx`: `@supabase/supabase-js` запоминает `fetch` в
 * конструкторе клиента, а клиент создаётся на импорте `modules/core/supabase/supabase` — патч,
 * поставленный позже, супабейс уже не увидит. Пока режимы выключены, обёртки прозрачны.
 *
 * Управление — кнопками джойстика или из консоли: `window.networkChaos`.
 */

import { networkChaos } from 'modules/overlay-v2/domain/utils/network-chaos';

if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
  networkChaos.install();
  (window as unknown as { networkChaos: typeof networkChaos }).networkChaos = networkChaos;
}
